import { withInstall } from '@zoryn/utils'
import InputTable from './src/input-table.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZInputTable: SFCWithInstall<typeof InputTable> =
  withInstall(InputTable)

export default ZInputTable
export * from './src/input-table'
